/* eslint-disable */
import { RematchDispatch } from '@rematch/core';
import { IRootModel } from 'app/store';
import { axiosErrorHandler } from 'common/helpers';
import { patientService } from 'entities/Patient/Patient.service';

export const patientEffects = (dispatch: RematchDispatch<IRootModel>) => ({
  async getPatientByEventId(eventId: number) {
    dispatch.patient.setLoading(true);

    try {
      const response = await patientService.getPatientByEventId(eventId);
      dispatch.patient.setPatient(response);
    } catch (error) {
      axiosErrorHandler(error);
    } finally {
      dispatch.patient.setLoading(false);
    }
  },
});
